<template>
  <div>
    <public-announcement :is-fixed="true" />
    <invitation-notifications v-if="userId" />
    <div class="app-page min-h-full">
      <div>
        <slot name="breadcrumb-content">
          <h2 class="truncate">
            {{ title }}
          </h2>
        </slot>
      </div>
      <div class="border-b border-secondary-20"></div>
      <section class="content flex flex-col flex-1">
        <slot name="content">
        </slot>
      </section>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import InvitationNotifications from '@/components-v2/common/global-notification/InvitationNotifications.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'

export default {
  components: {
    InvitationNotifications,
    PublicAnnouncement,
  },
  computed: {
    ...mapState({
      userId: (state) => state.currentUser.id,
    }),
    title() {
      const title = get(this, '$route.meta.title', '')
      return this.$i18nPresenter.t(title)
    },
  },
  mounted() {
  },
}
</script>
<style lang="scss" scoped>
.app-page {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1.5rem 2.5rem 5rem 2.5rem;
    @media (max-width: 600px) {
        padding: 1rem 1rem 5rem 1rem;
    }

    & > h2 {
      font-size: 1.5rem;
    }

    & > .action-buttons {
      display: flex;
      gap: 1rem;

      @media (max-width: 600px) {
        & > .new-presentation-btn {
          flex-grow: 1;
          flex-shrink: 1;
          flex-basis: 15%;
        }

        & > .import-btn {
          flex: 1;
        }
      }
    }
}
</style>
